import UniqeId1 from '../src/UniqueId'
import Tooltip1 from '../src/Tooltip/Tooltip'
import Validator1 from '../src/Validator/Validator'
import CreateBrandableTokens1 from '../src/CreateBrandableTokens'
export default {
    UniqeId:  UniqeId1,
    Tooltip:  Tooltip1,
    Validator: Validator1,
    CreateBrandableTokens: CreateBrandableTokens1
}